import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/notfoud.webp'


const _hoisted_1 = { class: "not-found" }


export default /*@__PURE__*/_defineComponent({
  __name: 'NotFound',
  setup(__props) {

// Not Found page

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("div", null, [
      _createElementVNode("img", {
        src: _imports_0,
        alt: "Profile Image",
        class: "not-founf-img"
      })
    ], -1),
    _createElementVNode("h1", null, "Oops.", -1),
    _createElementVNode("h2", null, "We can't find the SmartPage you're looking for.", -1),
    _createElementVNode("p", null, "It may have expired, or there could be a typo. Learn more about SmartPages from our homepage.", -1),
    _createElementVNode("a", {
      class: "home-link",
      href: "https://smartcardlabs.com/",
      target: "_blank"
    }, "Go to SmarCard Homepage", -1)
  ]))]))
}
}

})